import { render, staticRenderFns } from "./iconCheck.vue?vue&type=template&id=16b051da"
import script from "./iconCheck.vue?vue&type=script&lang=js"
export * from "./iconCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports